import { render, staticRenderFns } from "./ResultFilter.vue?vue&type=template&id=0cd631b2&"
import script from "./ResultFilter.vue?vue&type=script&lang=js&"
export * from "./ResultFilter.vue?vue&type=script&lang=js&"
import style0 from "./ResultFilter.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports